module.exports = "<div class=postcard-field> <h2 class=form-label> {{label}} </h2> <img ng-src=\"{{ media.original_file_url }}\" class=postcard-image> <p class=small><em>{{ media.caption }}</em></p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/detail/post-media-value.html
// module id = 694
// module chunks = 0